/**
 * The small green star that marks special-rules boards (maintainer,
 * 2026-11-03): beside the "Special rules" section headings in the map picker
 * and the map gallery, so the boards read as one family with the ★ rules
 * segment in a live game. Decorative: the heading text carries the meaning.
 */
import React from 'react'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { useTheme } from '../../hooks/useTheme'

export const SPECIAL_RULES_GREEN = { light: '#3B8A2E', dark: '#7FD36A' } as const

export function SpecialRulesStar({ size = 12, testID }: { size?: number; testID?: string }) {
  const { theme } = useTheme()
  return (
    <MaterialCommunityIcons
      name="star"
      size={size}
      color={SPECIAL_RULES_GREEN[theme]}
      testID={testID}
      accessibilityElementsHidden
      importantForAccessibility="no"
    />
  )
}
